import AboutUsModule from 'components/about-us/AboutUsModule';
import AboutUsSiteContainer from 'components/about-us/AboutUsSiteContainer';
import AboutUsSiteInnerContainer from 'components/about-us/AboutUsSiteInnerContainer';
import { InstagramFeed } from 'components/instagram-feed/InstagramFeed';
import { DaymadeDesignSystemPreviewComponentInfo } from '../';

const ComponentPreview = () => {
  return (
    <AboutUsModule background={'grey'} withNoPadding>
      <AboutUsSiteContainer>
        <div style={{ marginBottom: 24 }}>
          <h3 className="aboutUsTypographyHeaderLarge">Instagram Feed </h3>
          <p>
            <>
              The Instagram feed component, as used on the dashboard. It
              displays the latest 8 posts from the DAYMADE Instagram account,
              and links to the Instagram page when clicked.
            </>
          </p>
        </div>
        <AboutUsSiteInnerContainer background="white" borderRadius withPadding>
          <InstagramFeed />
        </AboutUsSiteInnerContainer>
      </AboutUsSiteContainer>
    </AboutUsModule>
  );
};

ComponentPreview.daymadeDesignSystemInfo = {
  name: 'Instagram Feed Preview',
} as DaymadeDesignSystemPreviewComponentInfo;

export default ComponentPreview;
